import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: { paddingRight: '8px' } }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"white","text-align":"right"} }, "Right-Content", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ minWidth: `${_ctx.rightSize}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_2
      ])
    ])
  ], 4))
}